export default __webpack_public_path__ + "static/media/hh2.9fc94108.png";